import { render, staticRenderFns } from "./TeamTask.vue?vue&type=template&id=4978614f&scoped=true&"
import script from "./TeamTask.vue?vue&type=script&lang=js&"
export * from "./TeamTask.vue?vue&type=script&lang=js&"
import style0 from "./TeamTask.vue?vue&type=style&index=0&id=4978614f&lang=scss&scoped=true&"
import style1 from "./TeamTask.vue?vue&type=style&index=1&id=4978614f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978614f",
  null
  
)

export default component.exports